import React, { useState, useEffect } from "react";
import { useMutation, gql } from "@apollo/client";
import LabledInput from "../CommonComponents/LabledInput";
import BackButton from "../CommonComponents/BackButton";
import CustomSelect from "../CommonComponents/CustomSelect";
import Loader from "../../Loader";

const ADD_PAYMENT = gql`
  mutation addPayment($data: PaymentInput!) {
    addPayment(data: $data) {
      status
      message
    }
  }
`;

const AddPaymentsModal = ({ setOpenModal }) => {
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");
  const [type, setType] = useState("debit");
  const [category, setCategory] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [description, setDescription] = useState("");
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [adminId, setAdminId] = useState("");
  const [payerName, setpayerName] = useState("");

  const [addPayment, { loading: mutationLoading }] = useMutation(ADD_PAYMENT);

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      amount: parseFloat(amount),
      date: new Date(date).toISOString(),
      type,
      category,
      paymentMethod,
      description,
      attachmentUrl,
      employeeId: employeeId || null,
      adminId,
      payerName,
    };

    addPayment({ variables: { data: payload } })
      .then((res) => {
        if (res.data.addPayment.status === "SUCCESS") {
          window.location.reload();
        } else {
          alert(res.data.addPayment.message);
        }
      })
      .catch((err) => console.error("Error adding payment:", err));
  };

  if (mutationLoading) return <Loader />;

  return (
    <div className="flex flex-col py-3 px-2 space-y-5">
      <BackButton onClick={() => setOpenModal(false)} />
      <h3 className="text-[#FBB033] font-be-jost-pro font-bold text-2xl">
        Add Payment
      </h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <LabledInput
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          label="Amount"
          placeholder="Enter amount"
          type="number"
        />
        <LabledInput
          value={date}
          onChange={(e) => setDate(e.target.value)}
          label="Date"
          type="datetime-local"
        />
        <CustomSelect
          label="Type"
          value={type}
          onChange={(e) => setType(e.target.value)}
          options={["debit", "credit"]}
        />
        <LabledInput
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          label="Category"
          placeholder="Enter category"
        />
        <CustomSelect
          label="Payment Method"
          value={paymentMethod}
          onChange={(e) => setPaymentMethod(e.target.value)}
          options={["cash", "bank_transfer", "upi", "card", "other"]}
        />
        <LabledInput
          value={payerName}
          onChange={(e) => setpayerName(e.target.value)}
          label="payer Name"
          placeholder="Enter payer name"
        />
        <LabledInput
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          label="Description"
          placeholder="Enter description"
        />
        <LabledInput
          value={attachmentUrl}
          onChange={(e) => setAttachmentUrl(e.target.value)}
          label="Attachment URL"
          placeholder="Enter attachment URL"
        />
        <LabledInput
          value={employeeId}
          onChange={(e) => setEmployeeId(e.target.value)}
          label="Employee ID (optional)"
          placeholder="Enter employee ID"
        />
        <LabledInput
          value={adminId}
          onChange={(e) => setAdminId(e.target.value)}
          label="Admin ID"
          placeholder="Enter admin ID"
          required
        />
        <div className="flex items-center justify-center">
          <button
            type="submit"
            className="bg-[#FBB034] text-[#202125] py-2 px-6 rounded-md font-poppins text-sm font-bold"
          >
            Submit Payment
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddPaymentsModal;
